import React from 'react'
import './styles.css'
import { useLocalState } from '../../shared/UseLocalState'
import { appState } from '../../state/App.state'
import { Toast } from '../../interfaces/Toast'

const ToastEntry = ({ toast }: { toast: Toast }) => {
  /* TEMPLATE */
  return <div className={`toast toast-${toast?.type}`}>{toast?.message}</div>
}

export const Toasts = () => {
  /* GLOBAL STATE */
  const toasts = useLocalState(appState.toasts$, appState.toasts$.value)

  /* TEMPLATE */
  return <div className={`toast-container`}>{toasts?.map((toast, i) => <ToastEntry key={i} toast={toast} />)}</div>
}
